"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.userlogout = exports.userlogin = exports.getuserdetails = void 0;

var _emcm = require("./requests/emcm");

var _createFetchRejection = _interopRequireDefault(require("../../api/utilities/createFetchRejection"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

var getuserdetails = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(apiBase, cors) {
    var response, json;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.next = 2;
            return (0, _emcm.getuserdetails)(apiBase, cors);

          case 2:
            response = _context.sent;
            _context.next = 5;
            return response.json();

          case 5:
            json = _context.sent;
            _context.t0 = json.Status;
            _context.next = _context.t0 === "Success" ? 9 : _context.t0 === "NotLoggedIn" ? 10 : 11;
            break;

          case 9:
            return _context.abrupt("return", {
              loggedIn: true,
              userName: json.userName
            });

          case 10:
            return _context.abrupt("return", {
              loggedIn: false
            });

          case 11:
            return _context.abrupt("return", (0, _createFetchRejection["default"])(response, json));

          case 12:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function getuserdetails(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();

exports.getuserdetails = getuserdetails;

var userlogin = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(apiBase, cors, jwt) {
    var response, json;
    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return (0, _emcm.userlogin)(apiBase, cors, jwt);

          case 2:
            response = _context2.sent;
            _context2.next = 5;
            return response.json();

          case 5:
            json = _context2.sent;
            _context2.t0 = json.Status;
            _context2.next = _context2.t0 === "Success" ? 9 : 10;
            break;

          case 9:
            return _context2.abrupt("return", {
              transferToken: json.transferToken
            });

          case 10:
            return _context2.abrupt("return", (0, _createFetchRejection["default"])(response, json));

          case 11:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function userlogin(_x3, _x4, _x5) {
    return _ref2.apply(this, arguments);
  };
}();

exports.userlogin = userlogin;

var userlogout = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(apiBase, cors) {
    var response, json;
    return regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return (0, _emcm.userlogout)(apiBase, cors);

          case 2:
            response = _context3.sent;
            _context3.next = 5;
            return response.json();

          case 5:
            json = _context3.sent;
            _context3.t0 = json.Status;
            _context3.next = _context3.t0 === "Success" ? 9 : 10;
            break;

          case 9:
            return _context3.abrupt("return");

          case 10:
            return _context3.abrupt("return", (0, _createFetchRejection["default"])(response, json));

          case 11:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));

  return function userlogout(_x6, _x7) {
    return _ref3.apply(this, arguments);
  };
}();

exports.userlogout = userlogout;